import superagent from 'superagent'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'


export const layersSet = layers => ({
  type: 'LAYERS_SET',
  payload: layers
})

// Layers added by this action are special becuase they wont come on the general get layers method,
// they wil be added to Redux for caching but should not be on the same dataset as the general layers
export const singleLayerSet = layer => ({
  type: 'SINGLE_LAYERS_SET',
  payload: layer
})

export const setLayersDictionary = layersObj => ({
  type: 'FLAT_LAYERS_SET',
  payload: layersObj
})

const correctOrder = (layers) => {
  const idxs = {
    '81': 0, //Google Img w/ Labels
    '7008': 7,
    '7009': 8,
    '7010': 9,
    '7011': 10,
    '82': 11, // Google Terrain
    '13': 12, // ESRI
    '12': 13, // USGS TOPO
    '18': 14, // ESRI TOPO
    '10': 15, // NATGEO
    '16': 16 // World Street Map
  }
  layers.forEach(layer => {
    layer.order = idxs[layer.id] ? idxs[layer.id] : layer.order
  })
}

const fillParentNodes = (layerNodes, activeLayers, dispatch) => {
  const layersToFill = layerNodes,
    vendorIds = [],
    layersFlat = {},
    searchNode = (parents, node) => {
      const parentClone = [].concat(parents)
      parentClone.push(node.id)
      if (node.layerNodes.length > 0) {
        node.layerNodes.forEach(searching => searchNode(parentClone, searching))
      }
      if (node.layers.length > 0) {
        node.layers.forEach(layer => {
          activeLayers.forEach(alayer => {
            if (!alayer) {
              return
            }
            if (layer.id === alayer.id) {
              alayer['parentNodes'] = parentClone
            }
          })
          if (!isNil(layer.vendorId) && !vendorIds.some(id => id === layer.vendorId)) {
            vendorIds.push(layer.vendorId)
          }
          layer['parentNodes'] = parentClone
          layersFlat[layer.id] = layer
        })
      }
    }
  layersToFill.forEach(node => searchNode([], node))
  layersFlat[891] = {
    id: 891,
    parentNodes: [5],
    layerNodeId: 5,
    overlayLayerId: 876
  }
  dispatch(setLayersDictionary(layersFlat))
  return { layers: layersToFill, vendors: vendorIds }
}

// Resolves only when layersDictionary has actually been populated. Callers rely on that:
// landing's validateLayers() deletes the user's saved layers if it runs against an empty
// catalog, so a failure here must surface as a rejection rather than a quiet resolve or a
// promise that never settles (WEB-7030).
export const layersFetchRequest = () => (dispatch, getState) => {
  let auth = getState().auth
  if (!auth || !auth.token) {
    return Promise.reject(new Error('layersFetchRequest: not authenticated'))
  }
  const cached = getState().layers
  if (!isNil(cached) && !isEmpty(cached)) {
    // state.layers is blacklisted from persistence, so a non-empty value means this
    // session already fetched and built layersDictionary.
    return Promise.resolve(cached)
  }
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI_3__}/layer/get`)
      .set('Authorization', `Bearer ${auth.token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
          return
        }
        // TODO: REMOVE HARD CODE
        const filters = [80, 891, 15, 17, 890]
        const userHasSub = (getState().user.userSubscription ?? []).filter(sub => sub.subscriptionPlanId === 4).length > 0
        if (userHasSub) {
          filters.push(7010)
          filters.push(7011)
        }
        const allLayers = res.body.layerNodes[0].layers
        let layers = allLayers.filter(layer => {
          return filters.indexOf(layer.id) === -1 && layer.platformId !== 1 && layer.platformId !== 2
        })
        correctOrder(layers)
        layers = layers.sort((a, b) => a.order - b.order)
        res.body.layerNodes[0].layers = layers
        const layerInfo = fillParentNodes(res.body.layerNodes, [], dispatch)
        dispatch(layersSet(res.body))
        resolve(res.body)
      })
  })
}

export const fetchLayerInfo = layerId => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI_3__}/layer/get/${layerId}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          resolve(res.body)
        }
      })
  })
}

export const fetchLayerToken = id => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI_2__}/auth/layerauth/${id}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          return resolve(err.status)
        }
        // let token = res.text
        //   .split('+')
        //   .join('%2B')
        //   .split('/')
        //   .join('%2F')
        //   .split('=')
        //   .join('%3D')
        let token = encodeURIComponent(res.text)
        resolve(token)
      })
  })
}

export const layerFetchRequest = (layerId) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI_3__}/Layer/Get/${layerId}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            resolve(err.status)
          }
          if (err.status === 404) {
            reject()
          }
          return
        }
        dispatch(singleLayerSet(res.body))
        resolve(res.body)
      })
  })
}
